import React from 'react';

import { AppNavigate, RoutePath } from '@/shared/lib/ts-router';
import { GetDefaultPathCallback } from '@/shared/lib/ts-router/types';

type DefaultPathRouteProps = {
  getDefaultPath: GetDefaultPathCallback;
};

export const DefaultPathRoute: React.FC<DefaultPathRouteProps> = ({ getDefaultPath }) => {
  const target = getDefaultPath({}) as RoutePath;

  return target ? <AppNavigate to={target} replace /> : <AppNavigate to="/" replace />;
};
